import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ArrowDown = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}  width="28" height="24" fill="none"  viewBox="0 0 56 42">
      <path d="M14 24L0 0H28L14 24Z" />
    </SvgIcon>
  );
};

export default ArrowDown;